module.exports = __webpack_public_path__ + "static/happyhappynewnew-476fc5148e0265c3152c33bde5ff557a.png";